import { render } from "./TypeVehicle.vue?vue&type=template&id=48330da1"
import script from "./TypeVehicle.vue?vue&type=script&lang=js"
export * from "./TypeVehicle.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__